// extracted by mini-css-extract-plugin
module.exports = {"list":"_6f25b66c20--list--QRwqt","link":"_6f25b66c20--link--LgHjM","link-active":"_6f25b66c20--link-active--3ATc8"};